import { GalleryImageObject, GalleryVideoObject } from "../../utils/utils.ts";

type Options = {
  includeRemainingVideos?: boolean;
  limitItemsOnGrid?: number;
  hideVideosOnGrid?: boolean;
  videoStartAt?: number;
};

const defaultOptions: Options = {
  videoStartAt: 2,
  includeRemainingVideos: false,
  hideVideosOnGrid: false,
};

export const buildContents = (
  images: GalleryImageObject[],
  videos: GalleryVideoObject[],
  options: Options = {},
) => {
  const contentOptions = { ...defaultOptions, ...options };

  if (contentOptions.hideVideosOnGrid) {
    return images;
  }

  const content = [
    ...images.slice(0, contentOptions.videoStartAt),
    ...videos.slice(0, 1),
    ...images.slice(contentOptions.videoStartAt, images.length),
  ];

  if (contentOptions.includeRemainingVideos) {
    content.push(...videos.slice(1, videos.length));
  }

  return content.slice(0, contentOptions.limitItemsOnGrid ?? content.length);
};
